<header class="header" [class.scrolled]="isScrolled">
  <div class="container">
    <!-- LOGO -->
    <a class="logo" href="/">
      <img [src]="header.imgUrl" [alt]="header.logoAlt" />
    </a>

    <!-- DESKTOP NAVIGATION -->
    <nav class="navigation">
      @for (item of navigation; track item.title) {
        <a [href]="item.url">
          {{ item.title }}
        </a>
      }
    </nav>

    <!-- DESKTOP ACTIONS -->
    <div class="actions">
      <div class="socials">
        @if (header.social.facebook) {
          <a [href]="header.social.facebook" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-facebook-f"></i>
          </a>
        }

        @if (header.social.instagram) {
          <a [href]="header.social.instagram" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-instagram"></i>
          </a>
        }

        @if (header.social.linkedin) {
          <a [href]="header.social.linkedin" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-linkedin-in"></i>
          </a>
        }

        @if (header.social.youtube) {
          <a [href]="header.social.youtube" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-youtube"></i>
          </a>
        }
      </div>

      @if (booking && booking.id) {
        <a class="book-btn" [href]="'#' + booking.id">
          {{ header.headerBtn }}
        </a>
      }
    </div>

    <!-- MOBILE HAMBURGER -->
    <button
      class="hamburger"
      [class.active]="menuOpen"
      (click)="toggleMenu()"
      type="button"
      [attr.aria-label]="header.menuButtonAriaLabel"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  <!-- =========================
       MOBILE MENU
       ========================= -->

  <div class="mobile-menu" [class.open]="menuOpen">
    <!-- MOBILE NAVIGATION -->
    <nav class="mobile-navigation">
      @for (item of navigation; track item.title) {
        <a [href]="item.url" (click)="closeMenu()">
          {{ item.title }}
        </a>
      }
    </nav>

    <!-- MOBILE SOCIALS -->
    <div class="mobile-socials">
      @if (header.social.facebook) {
        <a [href]="header.social.facebook" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-facebook-f"></i>
        </a>
      }

      @if (header.social.instagram) {
        <a [href]="header.social.instagram" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-instagram"></i>
        </a>
      }

      @if (header.social.linkedin) {
        <a [href]="header.social.linkedin" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-linkedin-in"></i>
        </a>
      }

      @if (header.social.youtube) {
        <a [href]="header.social.youtube" target="_blank" rel="noopener noreferrer">
          <i class="fab fa-youtube"></i>
        </a>
      }
    </div>

    <!-- MOBILE BOOK BUTTON -->
    @if (booking && booking.id) {
      <a class="mobile-book-btn" [href]="'#' + booking.id" (click)="closeMenu()">
        {{ header.headerBtn }}
      </a>
    }
  </div>
</header>
